import { useState } from 'react'

import { EuiFormRow, EuiFormRowProps } from '@elastic/eui'

export interface AcEuiFormRowProps {
  showErrorOnInitialLoad?: boolean
}

export const AcEuiFormRow = ({ children, isInvalid, showErrorOnInitialLoad = false, ...rest }: AcEuiFormRowProps & EuiFormRowProps) => {
  const [hasBlurred, setHasBlurred] = useState(false)
  const [isFocused, setIsFocused] = useState(false)

  const handleFocus = () => {
    setIsFocused(true)
  }

  const handleBlur = () => {
    setHasBlurred(true)
    setIsFocused(false)
  }

  const shouldShowInvalid = isInvalid && (showErrorOnInitialLoad || hasBlurred) && !isFocused

  return (
    <EuiFormRow onFocus={handleFocus} onBlur={handleBlur} isInvalid={shouldShowInvalid} {...rest}>
      {children}
    </EuiFormRow>
  )
}
